import { ref } from "vue";

export const availableRoutes = ref([]);

let routerInstance = null;
const dynamicRouteNames = new Set();
let resetHandler = () => {};

export const setRouterInstance = (router) => {
  routerInstance = router;
  refreshRoutes();
};

export const refreshRoutes = () => {
  if (routerInstance) {
    availableRoutes.value = routerInstance.getRoutes();
  }
};

export const getRouterInstance = () => routerInstance;

export const addDynamicRoutes = (routes) => {
  if (!routerInstance) return;

  routes.forEach((route) => {
    routerInstance.addRoute(route);
    if (route.name) dynamicRouteNames.add(route.name);
  });
  refreshRoutes();
};

export const addDynamicRoute = (route) => {
  if (!routerInstance) return;

  routerInstance.addRoute(route);
  refreshRoutes();
};

export const removeDynamicRoute = (name) => {
  if (!routerInstance) return;

  routerInstance.removeRoute(name);
  dynamicRouteNames.delete(name);
  refreshRoutes();
};

export const setDynamicRoutesResetHandler = (handler) => {
  resetHandler = handler;
};

export const resetDynamicRoutes = () => {
  if (routerInstance) {
    dynamicRouteNames.forEach((name) => routerInstance.removeRoute(name));
  }
  dynamicRouteNames.clear();
  resetHandler();
  refreshRoutes();
};
